var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{attrs:{"color":_vm.iconInfo.color}},[_vm._v(" "+_vm._s(_vm.iconInfo.icon)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }